module.exports = __webpack_public_path__ + "static/media/art46.36b829fc.jpg";